import React, { useEffect, useCallback } from "react";
import "./App.css";
import { Router, Route } from "react-router-dom";
import history from "./utils/history";
import asyncLocalStorage from "./utils/asyncLocalStorage";
import { useDispatch } from "react-redux";
import { getUserInfo } from "./redux/actions/userActions";
import PrivateRoute from "./components/common/privateRoute/PrivateRoute";
import HomePage from "./components/homePage";
import LoginPage from "./components/loginPage";
import SignIn from "./components/signInPage";
import BoatForm from "./components/formPage/boatForm";
import FormListPage from "./components/formListPage";
import ResultFormListPage from "./components/resultFormListPage";
import ProfilePage from "./components/profilePage";
export default function App() {
  const dispatch = useDispatch();

  const initFetch = useCallback(() => {
    asyncLocalStorage.getItem("pnc_popkey").then(data_popkey => {
      var popkey =
        data_popkey !== null && data_popkey.length > 0 ? data_popkey : null;
      if (popkey) dispatch(getUserInfo(popkey));
      else dispatch({ type: "NO_HAS_POPKEY" });
    });
  }, []);

  useEffect(() => {
    initFetch();
  }, []);

  return (
    <Router history={history}>
      <PrivateRoute exact path="/" component={HomePage} />
      <Route path="/login" component={LoginPage} />
      <Route path="/signin" component={SignIn} />
      <PrivateRoute path="/liste-formulaire" component={FormListPage} />
      <PrivateRoute path="/navire-formulaire" component={BoatForm} />
      <PrivateRoute path="/vos-déclarations" component={ResultFormListPage} />
      <PrivateRoute path="/profil" component={ProfilePage} />
    </Router>
  );
}
